import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY); // 16 bytes

const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV); // 16 bytes

// Function to encrypt a string
export const encrypt = (input) => {
  const text = input == null ? "" : String(input);
  return CryptoJS.AES.encrypt(text, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
};

// Function to decrypt a string
export const decrypt = (encryptedText) => {
  if (!encryptedText) return "";
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decrypt error:", error);
    return "";
  }
};

/**
 * Tách func name thành 2 phần và mã hóa
 * VD: CPN_spCustomerRecipient_List
 * => AppKey = encrypt("CPN_sp")
 * => SecretKey = encrypt("CustomerRecipient_List")
 */
export const generateSecurityKeys = (funcName) => {
  if (!funcName || typeof funcName !== 'string') {
    throw new Error('Invalid function name');
  }

  // Tìm vị trí của "_sp" để tách
  const splitPattern = '_sp';
  const splitIndex = funcName.indexOf(splitPattern);

  if (splitIndex === -1) {
    throw new Error(`Function name must contain "${splitPattern}"`);
  }

  // Tách thành 2 phần
  const part1 = funcName.substring(0, splitIndex + splitPattern.length); // VD: "CPN_sp"
  const part2 = funcName.substring(splitIndex + splitPattern.length); // VD: "CustomerRecipient_List"

  // Mã hóa
  const appKey = encrypt(part1);
  const secretKey = encrypt(part2);

  return {
    originalFunc: funcName,
    part1: part1,
    part2: part2,
    appKey: appKey,
    secretKey: secretKey,
    // Thêm timestamp để tránh replay attack (optional)
    timestamp: Date.now()
  };
};

/**
 * Giải mã và ghép lại func name
 */
export const reconstructFuncName = (appKey, secretKey) => {
  try {
    const part1 = decrypt(appKey);
    const part2 = decrypt(secretKey);
    
    if (!part1 || !part2) {
      throw new Error('Failed to decrypt keys');
    }

    return part1 + part2;
  } catch (error) {
    console.error('Reconstruct func name error:', error);
    throw error;
  }
};

export default {
  encrypt,
  decrypt,
  generateSecurityKeys,
  reconstructFuncName
};